export const MAX_ITEMS_PER_LIST = 10;
export const MAX_PAGE_ITEMS = 5;
export const INITIAL_PAGE_NUMBER = 1;
